<template>
    <div class="card" style="min-height: 200px">
        <div class="table-responsive">
            <table class="table">
                <thead>
                <tr>
                    <th style="width: 5%">
                        <input
                            type="checkbox"
                            :checked="allSelected"
                            @change="toggleSelectAll($event.target.checked)"
                        >
                    </th>
                    <th>Date</th>
                    <th>Bill Number</th>
                    <th class="text-right">Bill Amount</th>
                    <th>Party Name</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in purchase" :key="i">
                    <td>
                        <input type="checkbox" v-model="item.selected">
                    </td>
                    <td>{{ item.date }}</td>
                    <td>{{ item.bill_number }}</td>
                    <td class="text-right">{{ item.bill_amount }}</td>
                    <td>{{ item.party_name }}</td>
                    <td>
                        <button
                            class="btn btn-primary btn-sm"
                            @click="onView(item)"
                            style="cursor: pointer"
                        >
                            <i class="fas fa-eye"></i>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
            <p v-if="!purchase.length" class="text-center mt-5">No data</p>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    purchase: {
        type: Array,
        default: () => []
    }
})

const emit = defineEmits(['onView'])

const allSelected = computed(() => {
    if (!props.purchase.length) return false
    return props.purchase.every(item => item.selected === true)
})

const toggleSelectAll = (checked) => {
    props.purchase.forEach(item => {
        item.selected = checked
    })
}

const onView = (item) => {
    emit('onView', item)
}
</script>
